"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4617],{

/***/ 74617:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ scroll_parallax_homepage_first_fold_component; }
});

// EXTERNAL MODULE: ./components/enhancements/responsive-hoc/responsive-hoc-component.js + 1 modules
var responsive_hoc_component = __webpack_require__(27190);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/button-consts.js
var button_consts = __webpack_require__(75650);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
// EXTERNAL MODULE: ./components/core/new-button/button-component.js + 1 modules
var button_component = __webpack_require__(35061);
;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/scroll-parallax-homepage-first-fold/default-props.js



var defaultParagraphs = [
    {
        title: "Streamline your work for<br/><b>maximum productivity</b>",
        description: "Centralize all your work, processes, tools, and files into one Work OS. Connect teams, bridge silos, and maintain one source of truth across your organization.",
        avatarSrc: "https://dapulse-res.cloudinary.com/image/upload/r_400/f_auto,q_auto/remote_mondaycom_static/uploads/BarBen/jane.jpeg",
        avatarAlt: "Jane Tham's profile image",
        testimonial: "We use monday.com for a plethora of use cases, the opportunities this platform provides are limitless.",
        name: "Jane Tham",
        jobTitle: "VP of Collaboration Technologies",
        companyName: "Universal Music Group"
    },
    {
        title: "Bring teams together to<br/><b>drive business impact</b>",
        description: "Collaborate effectively organization-wide to get a clear picture of all your work. Stay in the loop with easy-to-use automations and real-time notifications.",
        avatarSrc: "https://dapulse-res.cloudinary.com/image/upload/r_400/f_auto,q_auto/remote_mondaycom_static/uploads/BarBen/sarah.jpeg",
        avatarAlt: "Sarah Pharr's profile image",
        testimonial: "Since adopting monday.com, our global marketing department has seen a 40% improvement in cross-team collaboration.",
        name: "Sarah Pharr",
        jobTitle: "AVP Marketing",
        companyName: "Genpact",
        buttonConfig: {
            buttonType: button_consts/* SIGNUP_BUTTON_TYPE */.ge,
            buttonColor: color_consts.WHITE_COLOR_NAME,
            invert: true,
            buttonSize: button_component.SM
        }
    },
    {
        title: "Stay on track to<br/><b>reach your goals, faster</b>",
        description: "Get a high-level overview of your organization with customizable dashboards. Make confident decisions and easily scale workflows for your evolving needs.",
        avatarSrc: "https://dapulse-res.cloudinary.com/image/upload/r_400/f_auto,q_auto/remote_mondaycom_static/uploads/BarBen/baptiste.jpeg",
        avatarAlt: "Baptiste Ancey's profile image",
        testimonial: "monday.com allows banks to be synchronized between the top-level management figures and local KPIs.",
        name: "Baptiste Ancey",
        jobTitle: "Head of Innovation",
        companyName: "Indosuez Wealth Management"
    }
];
/* harmony default export */ var default_props = ({
    alignToLogo: true,
    paragraphs: defaultParagraphs,
    topAsset: {
        src: "https://dapulse-res.cloudinary.com/image/upload/f_auto,q_auto/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/parallax/first_board.png",
        alt: "monday.com board with multiple integrations"
    },
    bottomAsset: {
        src: {
            formats: [
                "/Generator_featured images/Home Page - 2022 Rebrand/parallax/goals_dashboard.mp4"
            ]
        }
    }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./utils/general.js
var general = __webpack_require__(56093);
;// CONCATENATED MODULE: ./client/services/hooks/use-window-size.js


function getSize() {
    var _window, _document_documentElement, _document, _document_body, _document1, _window1, _document_documentElement1, _document2, _document_body1, _document3;
    if ((0,general/* isServerSide */.s$)()) {
        return {
            width: undefined,
            height: undefined
        };
    }
    return {
        width: ((_window = window) === null || _window === void 0 ? void 0 : _window.innerWidth) || ((_document = document) === null || _document === void 0 ? void 0 : (_document_documentElement = _document.documentElement) === null || _document_documentElement === void 0 ? void 0 : _document_documentElement.clientWidth) || ((_document1 = document) === null || _document1 === void 0 ? void 0 : (_document_body = _document1.body) === null || _document_body === void 0 ? void 0 : _document_body.clientWidth),
        height: ((_window1 = window) === null || _window1 === void 0 ? void 0 : _window1.innerHeight) || ((_document2 = document) === null || _document2 === void 0 ? void 0 : (_document_documentElement1 = _document2.documentElement) === null || _document_documentElement1 === void 0 ? void 0 : _document_documentElement1.clientHeight) || ((_document3 = document) === null || _document3 === void 0 ? void 0 : (_document_body1 = _document3.body) === null || _document_body1 === void 0 ? void 0 : _document_body1.clientHeight)
    };
}
function useWindowSize() {
    var ref = (0,react.useState)(getSize()), windowSize = ref[0], setWindowSize = ref[1];
    (0,react.useEffect)(function() {
        var handleResize = function handleResize() {
            setWindowSize(getSize());
        };
        if ((0,general/* isServerSide */.s$)()) {
            return false;
        }
        window.addEventListener("resize", handleResize);
        return function() {
            return window.removeEventListener("resize", handleResize);
        };
    }, []);
    return windowSize;
}

// EXTERNAL MODULE: ./node_modules/resize-observer-polyfill/dist/ResizeObserver.es.js
var ResizeObserver_es = __webpack_require__(91033);
;// CONCATENATED MODULE: ./client/services/hooks/use-rect.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


var useRect = function(ref) {
    var _$ref = (0,react.useState)(getRect(ref ? ref.current : null)), rect = _$ref[0], setRect = _$ref[1];
    var updateRect = (0,react.useCallback)(function() {
        if (!ref.current) return;
        // Update client rect
        setRect(getRect(ref.current));
    }, [
        ref
    ]);
    (0,react.useLayoutEffect)(function() {
        var element = ref.current;
        if (!element) return;
        updateRect();
        var resizeObserver = new ResizeObserver_es["default"](function() {
            return updateRect();
        });
        resizeObserver.observe(element);
        return function() {
            if (!resizeObserver) return;
            resizeObserver.disconnect();
            resizeObserver = null;
        };
    }, [
        ref.current
    ]);
    (0,react.useLayoutEffect)(function() {
        window.addEventListener("scroll", updateRect);
        return function() {
            window.removeEventListener("scroll", updateRect);
        };
    }, [
        ref.current
    ]);
    return rect;
};
function getRect(element) {
    if (!element) {
        return {
            height: 0,
            width: 0,
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            clientHeight: 0,
            clientWidth: 0,
            offsetTop: 0,
            offsetBottom: 0,
            offsetLeft: 0,
            offsetRight: 0
        };
    }
    var clientHeight = element.clientHeight, clientWidth = element.clientWidth, offsetTop = element.offsetTop, offsetBottom = element.offsetBottom, offsetLeft = element.offsetLeft, offsetRight = element.offsetRight;
    return _object_spread_props(_object_spread({}, element.getBoundingClientRect()), {
        clientHeight: clientHeight,
        clientWidth: clientWidth,
        offsetTop: offsetTop,
        offsetBottom: offsetBottom,
        offsetLeft: offsetLeft,
        offsetRight: offsetRight
    });
}
/* harmony default export */ var use_rect = (useRect);

// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var src_define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react-dom/server.browser.js
var server_browser = __webpack_require__(97762);
// EXTERNAL MODULE: ./components/core/asset/asset-component.js + 1 modules
var asset_component = __webpack_require__(49738);
// EXTERNAL MODULE: ./node_modules/typed.js/lib/typed.js
var lib_typed = __webpack_require__(13614);
var typed_default = /*#__PURE__*/__webpack_require__.n(lib_typed);
;// CONCATENATED MODULE: ./segments/desktop/core-components/typed-component/default-props.js
/* harmony default export */ var typed_component_default_props = ({
    typedProps: {
        strings: [
            "This is typed string"
        ],
        typeSpeed: 20,
        startDelay: 0,
        backSpeed: 20,
        backDelay: 700,
        smartBackspace: true,
        loop: false,
        shuffle: false
    }
});

// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./segments/desktop/core-components/typed-component/typed-component.scss.js

var StylesTypedComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e11l7vkl0"
})(".content{white-space:pre;font-size:0.875rem;.tag{color:#0981fc;}}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/typed-component/typed-component.js
function typed_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function typed_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            typed_component_define_property(target, key, source[key]);
        });
    }
    return target;
}






var TypedComponent = function(props) {
    var typedProps = props.typedProps, className = props.className, style = props.style, stopped = props.stopped;
    var ref = (0,react.useState)(0), timeElapsed = ref[0], setTimeElapsed = ref[1];
    var el = (0,react.useRef)(null);
    var typed = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        typed.current = new (typed_default())(el.current, typed_component_object_spread({}, typed_component_default_props.typedProps, typedProps));
        return function() {
            typed.current.destroy();
        };
    }, []);
    (0,react.useEffect)(function() {
        if (stopped) {
            typed.current.stop();
        } else {
            var _startDelay = typedProps.startDelay, startDelay = _startDelay === void 0 ? 0 : _startDelay;
            var startTime = performance.now();
            // Debouncing start if stopped in the proccess
            var delayTime = Math.max(0, startDelay - timeElapsed);
            var handler = setTimeout(function() {
                return typed.current.start();
            }, delayTime);
            return function() {
                var endTime = performance.now();
                var newTimeElapsed = timeElapsed + endTime - startTime;
                setTimeElapsed(newTimeElapsed);
                clearTimeout(handler);
            };
        }
    }, [
        stopped
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StylesTypedComponent, {
        className: classnames_default()("typed-component", className),
        style: style,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: "content",
            ref: el
        })
    });
};
/* harmony default export */ var typed_component = (TypedComponent);
TypedComponent.defaultProps = typed_component_default_props;

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/scroll-parallax-homepage-first-fold/parallax-galaxy.scss.js


var StyledParallaxGalaxy = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e9xx0fu0"
})('display:flex;justify-content:center;align-items:center;position:absolute;right:-11vw;top:-4vw;opacity:1;.galaxy-container{display:flex;justify-content:center;align-items:center;width:500px;height:500px;margin:0 auto;position:relative;}.galaxy-container .spin-container{position:relative;display:flex;justify-content:center;align-items:center;width:448px;height:448px;}/* circles backgrounds */\n    .galaxy-container .spin-container .circle-container{position:absolute;background-size:cover;background-position:center;background-repeat:no-repeat;animation:rotate-circle var(--d) linear infinite;}.galaxy-container .spin-container .circle-container.small-circle{width:200px;height:200px;background-image:url(https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/parallax/integrations/Ellipse3.svg);}.galaxy-container .spin-container .circle-container.medium-circle{--d:6s;/* duration */\n      width:270px;height:270px;background-image:url(https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/parallax/integrations/Ellipse2.svg);}.galaxy-container .spin-container .circle-container.large-circle{--d:15s;/* duration */\n      width:350px;height:350px;background-image:url(https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/parallax/integrations/Ellipse1.svg);}/* floating items */\n    .galaxy-container .spin-container .items-container{position:absolute;display:grid;place-content:center;}.galaxy-container .spin-container .items-container.small-circle{--n:3;/* number of item */\n      --d:9s;/* duration */\n      width:200px;height:200px;}.galaxy-container .spin-container .items-container.medium-circle{--n:2;/* number of item */\n      --d:14s;/* duration */\n      width:270px;height:270px;}.galaxy-container .spin-container .items-container.large-circle{--n:6;/* number of item */\n      --d:25s;/* duration */\n      width:350px;height:350px;}.item{grid-area:1/1;}/* small circle items */\n    .galaxy-container .spin-container .items-container.small-circle .item{width:auto;height:68px;animation:small-spin var(--d) linear infinite;transform:rotate(0) translate(95px) rotate(0);}.galaxy-container\n    .spin-container\n    .items-container.small-circle\n    .item:nth-child(1){animation-delay:calc(-0 * var(--d) / var(--n));}.galaxy-container\n    .spin-container\n    .items-container.small-circle\n    .item:nth-child(2){animation-delay:calc(-1 * var(--d) / var(--n));}.galaxy-container\n    .spin-container\n    .items-container.small-circle\n    .item:nth-child(3){animation-delay:calc(-2 * var(--d) / var(--n));}.galaxy-container .spin-container .items-container.small-circle .item img{width:auto;height:68px;}/* medium circle items */\n    .galaxy-container .spin-container .items-container.medium-circle .item{width:auto;height:62px;}.galaxy-container\n    .spin-container\n    .items-container.medium-circle\n    .item.item-inner{animation:medium-spin-inner var(--d) linear infinite;transform:rotate(0) translate(135px) rotate(0);}.galaxy-container\n    .spin-container\n    .items-container.medium-circle\n    .item.item-outer{animation:medium-spin-outer var(--d) linear infinite;transform:rotate(0) translate(175px) rotate(0);}.galaxy-container\n    .spin-container\n    .items-container.medium-circle\n    .item:nth-child(1){animation-delay:calc(-0 * var(--d) / var(--n));}.galaxy-container\n    .spin-container\n    .items-container.medium-circle\n    .item:nth-child(2){animation-delay:calc(\n              -1 * var(--d) / (var(--n) * 2)\n      );/* multiple --n for positioning of items */}.galaxy-container .spin-container .items-container.medium-circle .item img{width:auto;height:62px;}/* large circle items */\n    .galaxy-container .spin-container .items-container.large-circle .item{width:auto;height:50px;animation:large-spin var(--d) linear infinite;transform:rotate(0) translate(225px) rotate(0);}/* .galaxy-container .spin-container .items-container.large-circle .item.item-inner{animation:large-spin-inner var(--d) linear infinite;transform:rotate(0) translate(195px) rotate(0);}.galaxy-container .spin-container .items-container.large-circle .item.item-outer{animation:large-spin-outer var(--d) linear infinite;transform:rotate(0) translate(210px) rotate(0);}*/\n\n    .galaxy-container\n    .spin-container\n    .items-container.large-circle\n    .item:nth-child(1){animation-delay:calc(-0 * var(--d) / var(--n));}.galaxy-container\n    .spin-container\n    .items-container.large-circle\n    .item:nth-child(2){animation-delay:calc(-1 * var(--d) / (var(--n)));}.galaxy-container\n    .spin-container\n    .items-container.large-circle\n    .item:nth-child(3){animation-delay:calc(-1.5 * var(--d) / (var(--n)));}.galaxy-container\n    .spin-container\n    .items-container.large-circle\n    .item:nth-child(4){animation-delay:calc(-3 * var(--d) / (var(--n)));}.galaxy-container\n    .spin-container\n    .items-container.large-circle\n    .item:nth-child(5){animation-delay:calc(-4 * var(--d) / (var(--n)));}.galaxy-container .spin-container .items-container.large-circle .item img{width:auto;height:50px;}/* keyframes */\n    @keyframes small-spin{100%{transform:rotate(1turn) translate(95px) rotate(-1turn);}}@keyframes medium-spin-inner{100%{transform:rotate(1turn) translate(135px) rotate(-1turn);}}@keyframes medium-spin-outer{100%{transform:rotate(1turn) translate(175px) rotate(-1turn);}}@keyframes large-spin{100%{transform:rotate(1turn) translate(225px) rotate(-1turn);}}/* @keyframes large-spin-outer{100%{transform:rotate(1turn) translate(210px) rotate(-1turn);}}*/\n    @keyframes rotate-circle{from{transform:rotate(0);}to{transform:rotate(360deg);}}/* twinkling stars */\n\n    #twinkling-stars{position:absolute;left:0;top:0;width:100%;height:100%;background:transparent;.star{--twinkle-duration:"";--twinkle-delay:"";--star-size:"";position:absolute;background-image:url("https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/parallax/integrations/star.svg");background-repeat:no-repeat;background-size:cover;width:var(--star-size);height:var(--star-size);/* background:#fff;*/\n        border-radius:50%;animation:twinkle infinite alternate;animation-duration:var(--twinkle-duration);animation-delay:var(--twinkle-delay);will-change:transform;}}.circle{background-image:unset;background:#fff;}@keyframes twinkle{from{transform:scale(0);}to{transform:scale(1.5);/* box-shadow:inset 0 0 5px 0.5px rgba(255,255,255,0.6);*/}}}@media (max-width:', vp_sizes/* MD_DESKTOP_WIDTH */.JF, "){right:-33vw;top:-2vw;}");

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/scroll-parallax-homepage-first-fold/parallax-galaxy.js



var ParallaxGalaxy = function(props) {
    var createStars = function() {
        var $galaxy = document.getElementById("twinkling-stars");
        var randomNumber = function(min, max) {
            return Math.random() * (max - min) + min;
        };
        var createStar = function(isCircle, leftRange, rightRange) {
            var star = document.createElement("div");
            star.classList.add("star");
            if (isCircle) {
                star.classList.add("circle");
            }
            var x = randomNumber(1, $galaxy.offsetWidth * 0.75);
            var y = randomNumber(1, $galaxy.offsetHeight * 0.8);
            var style = star.style;
            style.left = "".concat(Math.floor(x), "px");
            style.top = "".concat(Math.floor(y), "px");
            style.setProperty("--star-size", "".concat(randomNumber(leftRange, rightRange), "px"));
            style.setProperty("--twinkle-duration", "".concat(Math.ceil(randomNumber(1, 3)), "s"));
            style.setProperty("--twinkle-delay", "".concat(Math.ceil(randomNumber(1, 8)), "s"));
            return star;
        };
        for(var index = 0; index < 24; index++){
            if (index < 16) {
                $galaxy === null || $galaxy === void 0 ? void 0 : $galaxy.append(createStar(false, 4, 10));
            } else {
                $galaxy === null || $galaxy === void 0 ? void 0 : $galaxy.append(createStar(true, 3, 6));
            }
        }
    };
    (0,react.useEffect)(function() {
        createStars();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledParallaxGalaxy, {
        className: "parallax-galaxy",
        style: props.style,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "galaxy-container",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "spin-container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        id: "twinkling-stars"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "circle-container small-circle"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "items-container small-circle",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "item gmail",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/parallax/integrations/gmail.svg",
                                    alt: "gmail integration icon"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "item linkedin",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/parallax/integrations/linkedin.svg",
                                    alt: "linkedin integration icon"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "item harvest",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/parallax/integrations/harvest.svg",
                                    alt: "harvest integration icon",
                                    className: "system__icon system__icon--sun"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "circle-container medium-circle"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "items-container medium-circle",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "item item-inner zoom",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/parallax/integrations/zoom.svg",
                                    alt: "zoom integration icon"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "item item-outer facebook-ads",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/parallax/integrations/facebook_ads.svg",
                                    alt: "facebook-ads integration icon"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "circle-container large-circle"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "items-container large-circle",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "item mailchimp",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/parallax/integrations/mailchimp.svg",
                                    alt: "mailchimp integration icon"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "item jira",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/parallax/integrations/jira.svg",
                                    alt: "jira integration icon"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "item salesforce",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/parallax/integrations/salesforce.svg",
                                    alt: "salesforce integration icon"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "item jotform",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/parallax/integrations/jotform.svg",
                                    alt: "jotform integration icon"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "item dropbox",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/parallax/integrations/dropbox.svg",
                                    alt: "dropbox integration icon"
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var parallax_galaxy = (ParallaxGalaxy);

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/scroll-parallax-homepage-first-fold/config.js

function _define_property1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property1(target, key, source[key]);
        });
    }
    return target;
}
function config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}





var VARIATIONS = {
    SMALL: "small",
    MEDIUM: "medium"
};
var STEP_1 = "step1";
var STEP_2 = "step2";
var STEP_3 = "step3";
var PERSON_WIDTH = 50;
var TYPED_COLUMN = 75;
var PERSON_ONE_SECOND_ROW = 100;
var PERSON_TWO_SECOND_ROW = 185;
var PERSON_THREE_SECOND_ROW = 270;
var PERSON_SECOND_SCALE = "scale(1)";
var SCENE_TRANSITION = "opacity 0.5s";
var PERSONS_FIRST_ANIMATION_TIMING = "0.6s";
var PERSONS_SECOND_ANIMATION_TIMING = "0.8s";
var PERSONS_FIRST_TRANSITION = "left ".concat(PERSONS_FIRST_ANIMATION_TIMING, " ease-out, top ").concat(PERSONS_FIRST_ANIMATION_TIMING, " ease-in-out, transform ").concat(PERSONS_FIRST_ANIMATION_TIMING, " ease-in-out");
var PERSONS_SECOND_TRANSITION = "left ".concat(PERSONS_SECOND_ANIMATION_TIMING, " ease-in-out, top ").concat(PERSONS_SECOND_ANIMATION_TIMING, " ease-in-out, transform ").concat(PERSONS_SECOND_ANIMATION_TIMING, " ease-in-out");
var PERSONS_IMAGES = [
    {
        image: {
            src: "https://dapulse-res.cloudinary.com/image/upload/v1649149959/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/parallax/person1.png",
            alt: "Samantha's profile image"
        }
    },
    {
        image: {
            src: "https://dapulse-res.cloudinary.com/image/upload/v1649149959/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/parallax/person2.png",
            alt: "Nate's profile image"
        }
    },
    {
        image: {
            src: "https://dapulse-res.cloudinary.com/image/upload/v1649149959/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/parallax/person3.png",
            alt: "Paloma's profile image"
        }
    }
];
var sizesMapping = function(variation) {
    var _obj;
    return (_obj = {}, (0,src_define_property/* default */.Z)(_obj, VARIATIONS.SMALL, {
        // ASSETS
        GALAXY_SCALE: "scale(0.75)",
        SPACE_BOARD_WIDTH: 450,
        SPACE_DASHBOARD_WIDTH: 450,
        // FIRST
        PERSON_FIRST_SCALE: "scale(0.3)",
        PERSON_FIRST_COLUMN: 145,
        PERSON_ONE_FIRST_ROW: 166,
        PERSON_TWO_FIRST_ROW: 229,
        PERSON_THREE_FIRST_ROW: 289,
        // SECOND
        PERSON_ONE_SECOND_ROW: 100,
        PERSON_TWO_SECOND_ROW: 185,
        PERSON_THREE_SECOND_ROW: 270,
        // THIRD
        PERSON_THIRD_SCALE: "scale(0.32)",
        PERSON_THIRD_ROW: 351,
        PERSON_ONE_THIRD_ROW: 250,
        PERSON_TWO_THIRD_ROW: 305,
        PERSON_THREE_THIRD_ROW: 360,
        TYPED_FONT_SIZE: 18
    }), (0,src_define_property/* default */.Z)(_obj, VARIATIONS.MEDIUM, {
        // ASSETS
        GALAXY_SCALE: "scale(1)",
        SPACE_BOARD_WIDTH: 600,
        SPACE_DASHBOARD_WIDTH: 600,
        // FIRST
        PERSON_FIRST_SCALE: "scale(0.4)",
        PERSON_FIRST_COLUMN: 202,
        PERSON_ONE_FIRST_ROW: 145,
        PERSON_TWO_FIRST_ROW: 229,
        PERSON_THREE_FIRST_ROW: 309,
        // SECOND
        PERSON_ONE_SECOND_ROW: 105,
        PERSON_TWO_SECOND_ROW: 190,
        PERSON_THREE_SECOND_ROW: 275,
        // THIRD
        PERSON_THIRD_SCALE: "scale(0.42)",
        PERSON_THIRD_ROW: 392,
        PERSON_ONE_THIRD_ROW: 343,
        PERSON_TWO_THIRD_ROW: 414,
        PERSON_THREE_THIRD_ROW: 487,
        TYPED_FONT_SIZE: 22
    }), _obj)[variation];
};
var getTypings = function(translate) {
    return [
        translate("parallex.typings.first"),
        translate("parallex.typings.second"),
        "".concat(server_browser.renderToString(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "text-with-pdf",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: translate("parallex.typings.third")
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: "pdf-icon",
                    src: "https://dapulse-res.cloudinary.com/image/upload/f_auto,q_auto/remote_mondaystagingcom_static/uploads/Bar%20Ben/pdf_icon.png"
                })
            ]
        })))
    ];
};
var getComponentsConfig = function(variation, translate, topAsset, bottomAsset) {
    var SIZES = sizesMapping(variation);
    var typings = getTypings(translate);
    return [
        //
        //
        // SPACE
        //
        //
        {
            id: "galaxy",
            props: function(step) {
                var _obj;
                return {
                    style: config_object_spread({
                        position: "absolute",
                        zIndex: 0,
                        transition: SCENE_TRANSITION,
                        transform: SIZES.GALAXY_SCALE,
                        right: -150,
                        top: -125,
                        opacity: 0
                    }, (_obj = {}, (0,src_define_property/* default */.Z)(_obj, STEP_1, {
                        opacity: 1
                    }), (0,src_define_property/* default */.Z)(_obj, STEP_2, {
                        opacity: 0
                    }), (0,src_define_property/* default */.Z)(_obj, STEP_3, {
                        opacity: 0
                    }), _obj)[step])
                };
            },
            component: parallax_galaxy
        },
        {
            id: "space-board",
            props: function(step) {
                var _obj;
                return {
                    image: topAsset,
                    useWindowMask: true,
                    width: SIZES.SPACE_BOARD_WIDTH,
                    style: config_object_spread({
                        position: "absolute",
                        zIndex: 1,
                        transition: SCENE_TRANSITION,
                        opacity: 0
                    }, (_obj = {}, (0,src_define_property/* default */.Z)(_obj, STEP_1, {
                        opacity: 1
                    }), (0,src_define_property/* default */.Z)(_obj, STEP_2, {
                        opacity: 0
                    }), (0,src_define_property/* default */.Z)(_obj, STEP_3, {
                        opacity: 0
                    }), _obj)[step])
                };
            },
            component: asset_component/* default */.Z
        },
        {
            id: "space-dashboard",
            props: function(step) {
                var _obj;
                return {
                    video: config_object_spread_props(config_object_spread({}, bottomAsset), {
                        playWhenVisible: false,
                        loop: false,
                        autoPlay: step === STEP_3
                    }),
                    hideControls: true,
                    useWindowMask: true,
                    width: SIZES.SPACE_DASHBOARD_WIDTH,
                    style: config_object_spread({
                        position: "absolute",
                        zIndex: 1,
                        transition: SCENE_TRANSITION,
                        opacity: 0
                    }, (_obj = {}, (0,src_define_property/* default */.Z)(_obj, STEP_1, {
                        opacity: 0
                    }), (0,src_define_property/* default */.Z)(_obj, STEP_2, {
                        opacity: 0
                    }), (0,src_define_property/* default */.Z)(_obj, STEP_3, {
                        opacity: 1
                    }), _obj)[step])
                };
            },
            component: asset_component/* default */.Z
        },
        //
        //
        // PEOPLE
        //
        //
        {
            id: "person-one",
            props: function(step) {
                return config_object_spread_props(config_object_spread({}, PERSONS_IMAGES[0]), {
                    width: PERSON_WIDTH,
                    style: config_object_spread({
                        position: "absolute",
                        zIndex: 2,
                        transition: PERSONS_FIRST_TRANSITION,
                        opacity: 0
                    }, {
                        step1: {
                            left: SIZES.PERSON_FIRST_COLUMN,
                            top: SIZES.PERSON_ONE_FIRST_ROW,
                            transform: SIZES.PERSON_FIRST_SCALE,
                            opacity: 1
                        },
                        step2: {
                            left: 0,
                            top: SIZES.PERSON_ONE_SECOND_ROW,
                            transform: PERSON_SECOND_SCALE,
                            opacity: 1
                        },
                        step3: {
                            transition: PERSONS_SECOND_TRANSITION,
                            left: SIZES.PERSON_ONE_THIRD_ROW,
                            top: SIZES.PERSON_THIRD_ROW,
                            transform: SIZES.PERSON_THIRD_SCALE,
                            opacity: 1
                        }
                    }[step])
                });
            },
            component: asset_component/* default */.Z
        },
        {
            id: "person-two",
            props: function(step) {
                return config_object_spread_props(config_object_spread({}, PERSONS_IMAGES[1]), {
                    width: PERSON_WIDTH,
                    style: config_object_spread({
                        position: "absolute",
                        zIndex: 2,
                        transition: PERSONS_FIRST_TRANSITION,
                        opacity: 0
                    }, {
                        step1: {
                            left: SIZES.PERSON_FIRST_COLUMN,
                            top: SIZES.PERSON_TWO_FIRST_ROW,
                            transform: SIZES.PERSON_FIRST_SCALE,
                            opacity: 1
                        },
                        step2: {
                            left: 0,
                            top: SIZES.PERSON_TWO_SECOND_ROW,
                            transform: PERSON_SECOND_SCALE,
                            opacity: 1
                        },
                        step3: {
                            transition: PERSONS_SECOND_TRANSITION,
                            left: SIZES.PERSON_TWO_THIRD_ROW,
                            top: SIZES.PERSON_THIRD_ROW,
                            transform: SIZES.PERSON_THIRD_SCALE,
                            opacity: 1
                        }
                    }[step])
                });
            },
            component: asset_component/* default */.Z
        },
        {
            id: "person-three",
            props: function(step) {
                return config_object_spread_props(config_object_spread({}, PERSONS_IMAGES[2]), {
                    width: PERSON_WIDTH,
                    style: config_object_spread({
                        position: "absolute",
                        zIndex: 2,
                        transition: PERSONS_FIRST_TRANSITION,
                        opacity: 0
                    }, {
                        step1: {
                            left: SIZES.PERSON_FIRST_COLUMN,
                            top: SIZES.PERSON_THREE_FIRST_ROW,
                            transform: SIZES.PERSON_FIRST_SCALE,
                            opacity: 1
                        },
                        step2: {
                            left: 0,
                            top: SIZES.PERSON_THREE_SECOND_ROW,
                            transform: PERSON_SECOND_SCALE,
                            opacity: 1
                        },
                        step3: {
                            transition: PERSONS_SECOND_TRANSITION,
                            left: SIZES.PERSON_THREE_THIRD_ROW,
                            top: SIZES.PERSON_THIRD_ROW,
                            transform: SIZES.PERSON_THIRD_SCALE,
                            opacity: 1
                        }
                    }[step])
                });
            },
            component: asset_component/* default */.Z
        },
        //
        //
        // TYPED COMPONENTS
        //
        //
        {
            id: "typed-1",
            props: function(step) {
                var _obj;
                return {
                    style: config_object_spread({
                        left: TYPED_COLUMN,
                        top: PERSON_ONE_SECOND_ROW,
                        position: "absolute",
                        fontSize: SIZES.TYPED_FONT_SIZE,
                        transition: "opacity 0.4s linear",
                        opacity: 0
                    }, (_obj = {}, (0,src_define_property/* default */.Z)(_obj, STEP_1, {
                        opacity: 0
                    }), (0,src_define_property/* default */.Z)(_obj, STEP_2, {
                        opacity: 1
                    }), (0,src_define_property/* default */.Z)(_obj, STEP_3, {
                        opacity: 0
                    }), _obj)[step]),
                    stopped: step !== STEP_2,
                    typedProps: {
                        strings: [
                            "".concat(typings[0])
                        ],
                        startDelay: 250
                    }
                };
            },
            component: typed_component
        },
        {
            id: "typed-2",
            props: function(step) {
                var _obj;
                return {
                    style: config_object_spread({
                        left: TYPED_COLUMN,
                        top: PERSON_TWO_SECOND_ROW,
                        position: "absolute",
                        fontSize: SIZES.TYPED_FONT_SIZE,
                        transition: "opacity 0.4s linear",
                        opacity: 0
                    }, (_obj = {}, (0,src_define_property/* default */.Z)(_obj, STEP_1, {
                        opacity: 0
                    }), (0,src_define_property/* default */.Z)(_obj, STEP_2, {
                        opacity: 1
                    }), (0,src_define_property/* default */.Z)(_obj, STEP_3, {
                        opacity: 0
                    }), _obj)[step]),
                    stopped: step !== STEP_2,
                    typedProps: {
                        strings: [
                            "".concat(typings[1])
                        ],
                        startDelay: 3000
                    }
                };
            },
            component: typed_component
        },
        {
            id: "typed-3",
            props: function(step) {
                var _obj;
                return {
                    style: config_object_spread({
                        left: TYPED_COLUMN,
                        top: PERSON_THREE_SECOND_ROW,
                        position: "absolute",
                        display: "flex",
                        fontSize: SIZES.TYPED_FONT_SIZE,
                        transition: "opacity 0.4s linear",
                        opacity: 0
                    }, (_obj = {}, (0,src_define_property/* default */.Z)(_obj, STEP_1, {
                        opacity: 0
                    }), (0,src_define_property/* default */.Z)(_obj, STEP_2, {
                        opacity: 1
                    }), (0,src_define_property/* default */.Z)(_obj, STEP_3, {
                        opacity: 0
                    }), _obj)[step]),
                    stopped: step !== STEP_2,
                    typedProps: {
                        strings: [
                            "".concat(typings[2])
                        ],
                        startDelay: 5500
                    }
                };
            },
            component: typed_component
        }
    ];
};
var steps = [
    STEP_1,
    STEP_2,
    STEP_3
];

// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/full-paragraph.js + 6 modules
var full_paragraph = __webpack_require__(13211);
;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/scroll-parallax-homepage-first-fold/parallex-paragraphs.scss.js

var DESCRIPTION_MAX_WIDTH = 500;
var SOCIAL_PROOF_TEXT_MAX_WIDTH = 400;
var PARAGRAPH_HEIGHT = 150;
var StyledParallexParagraphs = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e17zs3o0"
})(".paragraph{.bold{font-weight:bold;}&:first-child{.headline{margin-top:128px;}}.headline{margin-top:", PARAGRAPH_HEIGHT, "px;max-width:", DESCRIPTION_MAX_WIDTH, "px;.core-title-container .core-title{font-weight:300;}}.social-proof{display:flex;margin-top:", PARAGRAPH_HEIGHT, "px;align-items:center;.avatar{width:72px;height:72px;}.testimonial{font-size:0.875rem;line-height:24px;margin-left:16px;display:flex;.content{flex-grow:1;display:flex;flex-direction:column;max-width:", SOCIAL_PROOF_TEXT_MAX_WIDTH, "px;.company{font-size:0.8125rem;line-height:20px;}.person{display:flex;align-items:center;margin-top:8px;font-size:0.8125rem;line-height:20px;.text{font-weight:bold;}.divider{margin:0 4px;}.logo{width:auto;height:18px;}}}}}}");

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/scroll-parallax-homepage-first-fold/parallex-paragraphs.js



var ParallexParagraphs = function(props) {
    var paragraphs = props.paragraphs;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledParallexParagraphs, {
        className: "parallex-paragraphs",
        children: paragraphs.map(function(paragraph, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "paragraph",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "headline",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(full_paragraph/* default */.ZP, {
                            title: paragraph.title,
                            body: paragraph.description,
                            topic: {
                                text: ""
                            },
                            buttonConfig: paragraph.buttonConfig
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "social-proof",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: "avatar",
                                src: paragraph.avatarSrc,
                                alt: paragraph.avatarAlt
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "testimonial",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "“"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "content",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "main",
                                                children: [
                                                    paragraph.testimonial,
                                                    "”"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "person",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "text",
                                                        children: paragraph.name
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "divider",
                                                        children: "|"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "text",
                                                        children: paragraph.jobTitle
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "company",
                                                children: paragraph.companyName
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }, "paragraph_".concat(index));
        })
    });
};
/* harmony default export */ var parallex_paragraphs = (ParallexParagraphs);

// EXTERNAL MODULE: ./segments/desktop/header/layouts/components/basic-header/constants.js
var constants = __webpack_require__(72428);
// EXTERNAL MODULE: ./segments/desktop/constants.js
var desktop_constants = __webpack_require__(73759);
var constants_default = /*#__PURE__*/__webpack_require__.n(desktop_constants);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/scroll-parallax-homepage-first-fold/scroll-parallax-homepage-first-fold-component.scss.js
var sharedComponentStyles = "\n .text-with-pdf {\n    @keyframes fade-in {\n      0% {\n        opacity: 0;\n        transform: scale(0.5);\n      }\n      80% {\n        opacity: 1;\n        transform: scale(1.15);\n      }\n      100% {\n        transform: scale(1);\n      }\n    }\n\n    .pdf-icon {\n      width: 70px;\n      margin-left: -20px;\n      margin-top: -8px;\n      animation: fade-in 0.5s ease-in-out;\n    }\n  }\n";

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/scroll-parallax-homepage-first-fold/scroll-parallax-homepage-first-fold-desktop/scroll-parallax-homepage-first-fold-desktop-component.scss.js







var HEADER_LOGO_HORIZONTAL_PADDING = "".concat(constants/* default.HEADER_CONTENT_HORIZONTAL_PADDING */.Z.HEADER_CONTENT_HORIZONTAL_PADDING, "px");
var BODY_HORIZONTAL_PADDING = "".concat((constants_default()).BODY_CONTENT_HORIZONTAL_PADDING, "px");
var StyledScrollParallaxHomepageFirstFoldDesktopComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e18us6hf0"
})(sharedComponentStyles, "  background:", colors/* default */.Z[color_consts.SPACE_BLUE_COLOR_NAME], ";color:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";position:relative;padding:128px 0;.container{display:flex;max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px;margin:auto;padding:0 ", BODY_HORIZONTAL_PADDING, ";&.align-to-logo{padding-left:", HEADER_LOGO_HORIZONTAL_PADDING, ";padding-right:", HEADER_LOGO_HORIZONTAL_PADDING, ";}.paragraphs{flex:1 0 0;}.parallex{flex:1 0 0;position:relative;min-height:100%;padding-left:50px;.controller{height:500px;position:sticky;top:calc(50% - 250px);display:flex;flex-direction:column;justify-content:center;.window-mask{padding:0;}}}}@media (max-width:", vp_sizes/* MD_DESKTOP_WIDTH */.JF, "){.parallax-galaxy-wrapper{transform:scale(0.75);}}");

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/scroll-parallax-homepage-first-fold/scroll-parallax-homepage-first-fold-desktop/scroll-parallax-homepage-first-fold-desktop-component.js
function scroll_parallax_homepage_first_fold_desktop_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function scroll_parallax_homepage_first_fold_desktop_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            scroll_parallax_homepage_first_fold_desktop_component_define_property(target, key, source[key]);
        });
    }
    return target;
}










var ScrollParallaxHomepageFirstFoldDesktopComponent = function(props) {
    var alignToLogo = props.alignToLogo, paragraphs = props.paragraphs, translate = props.translate, bottomAsset = props.bottomAsset, topAsset = props.topAsset, backgroundColor = props.backgroundColor;
    var ref = useWindowSize(), windowWidth = ref.width;
    var parallexEl = (0,react.useRef)(null);
    var controllerEl = (0,react.useRef)(null);
    var parallexRect = use_rect(parallexEl);
    var controllerRect = use_rect(controllerEl);
    var variation = windowWidth >= vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld ? VARIATIONS.MEDIUM : VARIATIONS.SMALL;
    var componentsConfig = getComponentsConfig(variation, translate, topAsset, bottomAsset);
    var currentStep = steps[Math.floor(controllerRect.offsetTop * steps.length / parallexRect.clientHeight)];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledScrollParallaxHomepageFirstFoldDesktopComponent, {
        className: "scroll-parallax-homepage-first-fold-component-desktop",
        style: {
            backgroundColor: colors/* default */.Z[backgroundColor]
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classnames_default()("container", {
                "align-to-logo": alignToLogo
            }),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "paragraphs",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(parallex_paragraphs, {
                        paragraphs: paragraphs
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    ref: parallexEl,
                    className: "parallex",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        ref: controllerEl,
                        className: "controller",
                        children: componentsConfig.map(function(cc) {
                            var id = cc.id, _$props = cc.props, Component = cc.component;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, scroll_parallax_homepage_first_fold_desktop_component_object_spread({}, _$props(currentStep)), id);
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var scroll_parallax_homepage_first_fold_desktop_component = (ScrollParallaxHomepageFirstFoldDesktopComponent);

// EXTERNAL MODULE: ./segments/desktop/core-components/side-by-side-text-and-asset/side-by-side-text-and-asset.js + 1 modules
var side_by_side_text_and_asset = __webpack_require__(25641);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/signup-button/signup-button.js + 1 modules
var signup_button = __webpack_require__(85850);
// EXTERNAL MODULE: ./components/core/picture/picture-component.js + 3 modules
var picture_component = __webpack_require__(82305);
// EXTERNAL MODULE: ./constants/sizes.js
var sizes = __webpack_require__(77869);
// EXTERNAL MODULE: ./node_modules/react-visibility-sensor/visibility-sensor.js
var visibility_sensor = __webpack_require__(51529);
var visibility_sensor_default = /*#__PURE__*/__webpack_require__.n(visibility_sensor);
;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/scroll-parallax-homepage-first-fold/scroll-parallax-homepage-first-fold-mobile-component/scroll-parallax-homepage-first-fold-mobile-component.scss.js




var StyledScrollParallaxHomepageFirstFoldMobileComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1vn7em70"
})(sharedComponentStyles, "  background:", colors/* default */.Z[color_consts.SPACE_BLUE_COLOR_NAME], ";.full-paragraph-component-wrapper{padding-bottom:20px;}.middle-paragraph-and-asset{padding-bottom:24px;}.top-asset-wrapper{.asset-inner{padding-top:72px;}}.top-asset-wrapper,.bottom-asset-wrapper{.parallax-galaxy-wrapper{transform:scale(0.4);top:5vw;right:-28vw;position:relative;}}.middle-asset-wrapper{width:100%;min-height:250px;.typing-wrapper{display:flex;margin-top:24px;.picture-component{padding-right:8px;img{width:40px;}}}.typing-wrapper:last-child{.typed-component{display:flex;}}}.side-by-side-text-and-asset{.side-by-side-content.is-full-width{padding-top:60px;padding-bottom:0;}}");

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/scroll-parallax-homepage-first-fold/scroll-parallax-homepage-first-fold-mobile-component/scroll-parallax-homepage-first-fold-mobile-component.js
function scroll_parallax_homepage_first_fold_mobile_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function scroll_parallax_homepage_first_fold_mobile_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            scroll_parallax_homepage_first_fold_mobile_component_define_property(target, key, source[key]);
        });
    }
    return target;
}













var ScrollParallaxHomepageFirstFoldMobileComponent = function(props) {
    var VISIBILITY_SENSOR_OFFSET = 0;
    var ref = (0,react.useState)(false), shouldRerenderWhenVisible = ref[0], setShouldRerenderWhenVisible = ref[1];
    var paragraphs = props.paragraphs, topAsset = props.topAsset, bottomAsset = props.bottomAsset, translate = props.translate;
    var mobileParagraphs = paragraphs.map(function(paragraph) {
        return {
            paragraph: {
                title: paragraph.title,
                titleSize: sizes.SM,
                body: paragraph.description,
                topic: ""
            }
        };
    });
    var topAssetComponent = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "top-asset-wrapper",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "parallax-galaxy-wrapper",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(parallax_galaxy, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(asset_component/* default */.Z, {
                    image: topAsset,
                    useWindowMask: true
                })
            ]
        });
    };
    var middleAssetComponent = function() {
        var getComponentProps = function(index) {
            var delays = [
                250,
                3000,
                5500
            ];
            return {
                typedProps: {
                    strings: [
                        "".concat(getTypings(translate)[index])
                    ],
                    startDelay: delays[index]
                }
            };
        };
        var onVisibilityChange = function(isVisible) {
            if (!shouldRerenderWhenVisible && isVisible) {
                setShouldRerenderWhenVisible(true);
            }
        };
        return /*#__PURE__*/ (0,jsx_runtime.jsx)((visibility_sensor_default()), {
            offset: {
                bottom: VISIBILITY_SENSOR_OFFSET,
                top: VISIBILITY_SENSOR_OFFSET
            },
            partialVisibility: true,
            active: true,
            scrollCheck: true,
            onChange: onVisibilityChange,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "middle-asset-wrapper",
                children: PERSONS_IMAGES.map(function(value, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "typing-wrapper",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, scroll_parallax_homepage_first_fold_mobile_component_object_spread({}, PERSONS_IMAGES[index].image)),
                            shouldRerenderWhenVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)(typed_component, scroll_parallax_homepage_first_fold_mobile_component_object_spread({}, getComponentProps(index)))
                        ]
                    });
                })
            })
        });
    };
    var bottomAssetComponent = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "bottom-asset-wrapper",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(asset_component/* default */.Z, {
                video: bottomAsset,
                useWindowMask: true
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledScrollParallaxHomepageFirstFoldMobileComponent, {
        className: "scroll-parallax-homepage-first-fold-mobile-component",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(side_by_side_text_and_asset/* default */.Z, {
                background: {
                    color: color_consts.SPACE_BLUE_COLOR_NAME,
                    width: "100%"
                },
                fullParagraph: mobileParagraphs[0].paragraph,
                replaceAssetComponent: topAssetComponent,
                contentClassName: "top-paragraph-and-asset"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(side_by_side_text_and_asset/* default */.Z, {
                background: {
                    color: color_consts.SPACE_BLUE_COLOR_NAME,
                    width: "100%"
                },
                fullParagraph: mobileParagraphs[1].paragraph,
                replaceAssetComponent: middleAssetComponent,
                contentClassName: "middle-paragraph-and-asset"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(side_by_side_text_and_asset/* default */.Z, {
                background: {
                    color: color_consts.SPACE_BLUE_COLOR_NAME,
                    width: "100%"
                },
                fullParagraph: mobileParagraphs[2].paragraph,
                replaceAssetComponent: bottomAssetComponent,
                contentClassName: "bottom-paragraph-and-asset"
            })
        ]
    });
};
/* harmony default export */ var scroll_parallax_homepage_first_fold_mobile_component = (ScrollParallaxHomepageFirstFoldMobileComponent);

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/scroll-parallax-homepage-first-fold/scroll-parallax-homepage-first-fold-component.js




var ScrollParallaxHomepageFirstFoldComponent = (0,responsive_hoc_component/* default */.Z)(scroll_parallax_homepage_first_fold_desktop_component, scroll_parallax_homepage_first_fold_mobile_component);
ScrollParallaxHomepageFirstFoldComponent.defaultProps = default_props;
/* harmony default export */ var scroll_parallax_homepage_first_fold_component = (ScrollParallaxHomepageFirstFoldComponent);


/***/ })

}]);